import { pipe } from 'lodash/fp';

export const removeWhitespaces = (value: string) => value.replace(/\s/g, '');

export const replaceCommaWithDot = (value: string) => value.replace(/,/g, '.');

/**
 * 1. remove letters when they are in the middle or something (gi --> g global, i case insensitive)
 * 2. remove all whitespaces
 * 3. remove all other chars accept .
 */
export const removeAllDisallowedChars = (value: string) => value.replace(/[^0-9.]/gi, '');

export const trimNumberToPrecision = (precision: number) => (value: number | string) => {
  // check length after dot so its limited to precision
  const splitted = `${value}`.split('.');

  if (splitted && splitted.length > 1) {
    const afd = splitted[1];

    if (afd && afd.length > Number(precision)) {
      return `${splitted[0]}.${afd.substring(0, precision)}`;
    }
  }

  return `${value}`;
};

export const getAfterDotDigitsNumber = (value?: string | number) => {
  if (!value) {
    return 0;
  }

  const splitted = value.toString().split('.');

  if (splitted && splitted.length > 1) {
    return splitted[1]?.length ?? 0;
  }

  return 0;
};

export const removeUnwantedChars = (precision: number) => pipe(removeWhitespaces, replaceCommaWithDot, removeAllDisallowedChars, trimNumberToPrecision(precision));
